import React, { useEffect, useRef } from "react";
import { isEmpty, findLast, uniqBy } from "lodash";
import { useForm } from "react-hook-form";
import { useQuery, useMutation } from "@apollo/client";

import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import MuiTextField from "@material-ui/core/TextField";

import { text2html } from "~/shared/utils/text2html";
import { isNullDate } from "~/shared/utils/sharedUtils";

import {
  GET_PATIENT_CARE_MESSAGES,
  CREATE_PATIENT_CARE_MESSAGE,
  CREATE_PATIENT_READ_RECEIPT_ON_LATEST_PATIENT_CARE_MESSAGE,
} from "./portalQueries";

import { usePortalStyles, kickColors } from "../styles/portalStyles";

let cacheLatestCareMessageID = "";

function GetPatientCareMessages() {
  const [createPatientReadReceiptOnLatestPatientCareMessage] = useMutation(
    CREATE_PATIENT_READ_RECEIPT_ON_LATEST_PATIENT_CARE_MESSAGE,
    {
      update(cache) {
        const data = cache.readQuery({
          query: GET_PATIENT_CARE_MESSAGES,
        });
        if (!data) return;
        const readMsgs = data.patientCareMessages.map((m) => {
          const readMsg = { ...m };
          if (isNullDate(readMsg.readAt)) {
            readMsg.readAt = new Date().toISOString();
          }
          return readMsg;
        });
        cache.writeQuery({
          query: GET_PATIENT_CARE_MESSAGES,
          data: {
            patientCareMessages: readMsgs,
          },
        });
      },
    }
  );

  const checkAndCreateReceiptOnLatest = async (data) => {
    // grab the last message from an EMR User
    let lastMessageFromEMRUser = findLast(data.patientCareMessages, (m) => {
      return m.emrUserLastName != "";
    });

    // create a read receipt if the last message has changed
    if (
      lastMessageFromEMRUser &&
      lastMessageFromEMRUser.id != cacheLatestCareMessageID
    ) {
      let results = await createPatientReadReceiptOnLatestPatientCareMessage();

      cacheLatestCareMessageID =
        results.data.createPatientReadReceiptOnLatestPatientCareMessage
          .messageID;
    }
  };

  const { loading, error, data } = useQuery(GET_PATIENT_CARE_MESSAGES, {
    pollInterval: 30 * 1000,
    // onCompleted: (data) => {
    //   checkAndCreateReceiptOnLatest(data);
    // },
  });

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{`Error! ${error.message}`}</p>;

  checkAndCreateReceiptOnLatest(data);

  return <PatientCareMessagesList messages={data} />;
}

function PatientCareMessagesList(data) {
  const classes = usePortalStyles();
  const noMessagesYet = isEmpty(data.messages.patientCareMessages);
  const messagesEndRef = useRef(null);
  const messagesListRef = useRef(null);

  useEffect(() => {
    // messagesEndRef.current &&
    //   messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    // messagesEndRef.current.scrollTop = messagesEndRef.current.scrollHeight;
    // scroller.scrollTo("messagesEnd", {
    //   // duration: 1500,
    //   isDynamic: true,
    //   delay: 1000,
    //   smooth: true,
    //   containerId: "messagesList",
    //   offset: 1000, // Scrolls to element + 50 pixels down the page
    // });

    // messagesListRef.current &&
    messagesListRef.current.scrollTop = messagesListRef.current.scrollHeight;
  });

  return (
    <React.Fragment>
      <div
        id="messagesList"
        ref={messagesListRef}
        style={{
          display: "flex",
          alignItems: noMessagesYet ? "center" : "flex-start",
          justifyContent: noMessagesYet ? "center" : "flex-start",
          flexDirection: "column",
          width: "100%",
          marginBottom: "20px",
          paddingBottom: "10px",
          // paddingLeft: "20px",
          // paddingRight: "20px",
          overflowY: "auto",
          flexGrow: 1,
          // backgroundColor: `radial-gradient(circle at 100% 100%, rgba(lightblue, 0.8),rgba(pink, 0.05)), radial-gradient(circle at 100% 0%, rgba(#e3ade6, 0.05), rgba(#e3ade6, 0.8)), radial-gradient(circle at 20% 50%, rgba(yellow, 0.5), rgba(pink, 0.1))`,
          // backgroundColor: "white",

          // border: "3px solid red",
        }}
      >
        <h3 style={{ width: "100%", textAlign: "center" }}>
          Message the Kick Care Team
        </h3>
        <Divider style={{ margin: "6px 0 4px 0" }} />

        <Typography
          style={{ width: "100%", marginBottom: "16px", textAlign: "center" }}
        >
          Send a secure, private messge to your personal care team. We'll send
          you an email notification when we respond.
        </Typography>

        {data.messages.patientCareMessages.map((row) => {
          const fromPatient = isEmpty(row.emrUserLastName);
          const messageRawMarkup = {
            __html: text2html(row.message),
          };

          return (
            <div
              key={row.id}
              style={{
                display: "flex",
                flexShrink: 0,
                flexDirection: "row",
                marginTop: "10px",
                marginLeft: "20px",
                marginRight: "20px",
                padding: "18px 10px 18px 10px",
                fontSize: "16px",
                width: "70%",

                background: fromPatient
                  ? // ? "linear-gradient(#5867fb, #3F51B5)"
                    "linear-gradient(20deg, #3F51B5 25%, #3f3f82 80%)"
                  : `linear-gradient(20deg, #f7fcff 25%, 60%, #fff2f0 80%)`,

                color: fromPatient ? "white" : kickColors.navy,
                alignSelf: fromPatient ? "flex-end" : "flex-start",
                borderRadius: "10px",
              }}
            >
              <div style={{ flex: 1, flexDirection: "column" }}>
                <div style={{ margin: "0" }}>
                  <span dangerouslySetInnerHTML={messageRawMarkup}></span>

                  {!fromPatient ? (
                    <div style={{ marginTop: "12px", fontSize: "12px" }}>
                      {"From "}
                      <strong>
                        {`${row.emrUserFirstName} ${row.emrUserLastName}`}
                      </strong>
                      {" at "} {new Date(row.createdAt).toLocaleString()}
                    </div>
                  ) : (
                    <div style={{ marginTop: "12px", fontSize: "12px" }}>
                      {new Date(row.createdAt).toLocaleString()}
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div name="messagesEnd" ref={messagesEndRef} />
    </React.Fragment>
  );
}

function renderMessageInput() {
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { isSubmitting, errors },
  } = useForm();

  const [sendMessage, { data }] = useMutation(CREATE_PATIENT_CARE_MESSAGE, {
    update(cache, { data: { createPatientCareMessage } }) {
      // update the cache
      const cacheData = cache.readQuery({
        query: GET_PATIENT_CARE_MESSAGES,
      });

      cache.writeQuery({
        query: GET_PATIENT_CARE_MESSAGES,
        data: {
          patientCareMessages: uniqBy(
            [...cacheData.patientCareMessages, createPatientCareMessage],
            "id"
          ),
        },
      });
    },
  });

  // for react-hook-form
  const { registerRef, ...registerRest } = register("message");

  return (
    <React.Fragment>
      <Divider style={{ marginTop: "6px" }} />
      <form
        style={{
          width: "98%",
          marginTop: "10px",
          display: "flex",
          // alignItems: "center",
          alignSelf: "center",
          flexDirection: "column",
        }}
        onSubmit={handleSubmit(async (data, e) => {
          if (!data.message.trim()) {
            return;
          }
          await sendMessage({
            variables: { message: data.message },
          });

          e.target.reset();
          reset();
        })}
      >
        <MuiTextField
          inputRef={registerRef}
          {...registerRest}
          name="message"
          placeholder="Whats on your mind...?"
          multiline
          fullWidth
          inputProps={{ minRows: 3 }}
          variant="outlined"
          style={{
            backgroundColor: "white",
          }}
        />
        <div style={{ display: "flex", flexDirection: "row-reverse" }}>
          <Button
            type="submit"
            disabled={isSubmitting}
            style={{
              display: "block",
              backgroundColor: kickColors.blue,
              color: "white",
              width: "130px",
              marginTop: "10px",
              marginBottom: "10px",
              // marginRight: "10px",
            }}
          >
            Send Message
          </Button>
        </div>
      </form>
    </React.Fragment>
  );
}

export default function PortalPatientCareMessages() {
  const classes = usePortalStyles();

  return (
    <main
      className={classes.content}
      style={{
        display: "flex",
        // flexWrap: "wrap",
        flexDirection: "column",
        alignContent: "space-between",
        alignItems: "center",
        // flexShrink: 0,
        // width: "95%",
        // border: "4px solid green",
      }}
    >
      <GetPatientCareMessages />

      <div
        style={{
          justifyContent: "flex-end",
          display: "flex",
          width: "100%",
          marginTop: "auto", // pin to bottom of dscreen
          height: "160px",
          flexDirection: "column",
        }}
      >
        {renderMessageInput()}
      </div>
    </main>
  );
}
